import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { fetchSections, fetchSection } from '../../api/sections'
import {fetchCollection} from "../../api/collections";

export default function Introduction() {
    // 1. Setup State
    const [section, setSection] = useState(null)
    const [error, setError] = useState(null);

    // 2. Get Sections
    useEffect(() => {
        let cancelled = false;
        setSection(null);
        setError(null);
        fetchSection('INTRODUCTION')
          .then(({ sections: data }) => {
                if (!cancelled) setSection(data[0]);
          })
          .catch((err) => {
            if (!cancelled) setError(err.message || 'Failed to load collection.');
          });
     return () => {
       cancelled = true;
    };
  }, []);

    if(!section){
        return (<></>)
    }

    return (
        <section className='introduction'>
            <div className='introduction-container'>
                <div className='introduction-header'>
                    <span className='introduction-accent-line' />
                    <span className='introduction-eyebrow'>Members Only</span>
                    <h2>{section.header}</h2>
                </div>
                <div className='introduction-body'>
                    <p>{section.body}</p>
                </div>
                <div className='introduction-footer'>
                    <Link className='introduction-cta' to={`https://www.fleshlight.com/pages/sleeve-of-the-month`}>
                        {section.footer}
                    </Link>
                </div>
            </div>
        </section>
    )

}